/**
 * One-time reveal for elements marked [data-sk-reveal] as they scroll into view.
 * Elements already on screen when the page loads are never hidden, so the first screen and the LCP image stay static.
 * Under prefers-reduced-motion nothing is hidden and autoplaying product videos are paused.
 */
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

if (reduceMotion) {
  for (const video of document.querySelectorAll('deferred-media[autoplay] video')) {
    video.removeAttribute('autoplay');
    video.pause();
  }
} else if ('IntersectionObserver' in window && !window.Shopify?.designMode) {
  const items = Array.from(document.querySelectorAll('[data-sk-reveal]'));
  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -10% 0px' }
  );

  for (const item of items) {
    if (item.getBoundingClientRect().top < window.innerHeight) {
      item.classList.add('is-revealed');
    } else {
      observer.observe(item);
    }
  }
  document.documentElement.classList.add('sk-reveal-ready');
}
